module.exports = __webpack_public_path__ + "img/wzgg.808e141e.png";